@if (activity(); as activity) {
	<app-cms-badge [color]="activity.first_rubric_level?.toString()">
		{{ activity.first_rubric_level?.toString() }}
	</app-cms-badge>
}
